/**
 * Provider Experience Routes
 * legacy app: canActivate: [AuthGuard, VendorRoleGuard, RoleGuard]
 * data: { checkRoleFor: 'UHCI_PEM' }
 */

import React, { lazy } from 'react';
import { RouteConfig, RouteMetadata } from '../../types';

const ProviderExperience = lazy(() => import('@src/apps/ProviderExperience/ProviderExperience-connect'));

const EXTERNAL_ACCESS_DENIED: Pick<RouteMetadata, 'externalAccess'> = {
  externalAccess: false,
};

const providerExperienceRouteFrameStyles: React.CSSProperties = {
  width: '60rem',
  maxWidth: '100%',
  margin: '0 auto',
  boxSizing: 'border-box',
};

const ProviderExperienceRouteFrame: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div style={providerExperienceRouteFrameStyles}>{children}</div>
);

const ProviderExperienceRoute = () => (
  <ProviderExperienceRouteFrame>
    <ProviderExperience />
  </ProviderExperienceRouteFrame>
);

export const providerExperienceRoutes: RouteConfig[] = [
  {
    path: 'provider-experience/*',
    component: ProviderExperienceRoute,
    guards: ['auth', 'vendor', 'role'],
    data: {
      ...EXTERNAL_ACCESS_DENIED,
      title: 'Provider Experience',
      breadcrumb: 'Provider Experience',
      preload: false,
      delay: true,
      checkRoleFor: 'UHCI_PEM',
    },
  },
];

